<template>
  <div class="bg-white py-20 px-5 lg:px-8 lg:py-28">
    <div class="mx-auto max-w-7xl">
      <div class="overflow-hidden rounded-[1.75rem] border border-navy-100 shadow-lift">
        <div class="grid lg:grid-cols-2">
          <!-- copy side -->
          <div class="bg-navy-50/70 p-8 sm:p-12">
            <p class="eyebrow">Contact</p>
            <h2 class="mt-4 text-4xl font-extrabold tracking-tight text-navy-950 sm:text-[2.75rem]">
              Let's get you a quote.
            </h2>
            <p class="mt-5 text-lg leading-8 text-navy-600">
              Whichever way suits you. A quick call is usually fastest, but send a photo over social
              and we'll price it from there.
            </p>

            <ul class="mt-10 space-y-3 text-sm font-medium text-navy-700">
              <li v-for="point in points" :key="point" class="flex items-start gap-3">
                <i class="fas fa-check mt-1 text-xs text-sky-400"></i>{{ point }}
              </li>
            </ul>

            <div class="mt-10 overflow-hidden rounded-2xl ring-1 ring-navy-900/5">
              <img src="../assets/wash.webp" alt="" aria-hidden="true" class="h-40 w-full object-cover" />
            </div>
          </div>

          <!-- channels side -->
          <div class="divide-y divide-navy-100 bg-white">
            <a
              v-for="channel in channels"
              :key="channel.label"
              :href="channel.href"
              :target="channel.external ? '_blank' : undefined"
              :rel="channel.external ? 'noreferrer' : undefined"
              class="group flex items-center gap-5 p-7 transition hover:bg-navy-50/60 sm:p-9"
            >
              <span class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy-50 text-navy-700 ring-1 ring-navy-100 transition group-hover:bg-navy-900 group-hover:text-white">
                <i :class="[channel.icon, 'text-lg']"></i>
              </span>
              <span class="min-w-0">
                <span class="block text-xs font-semibold uppercase tracking-[0.18em] text-navy-500">{{ channel.label }}</span>
                <span class="mt-1 block truncate text-lg font-bold text-navy-950">{{ channel.value }}</span>
                <span class="mt-0.5 block text-sm text-navy-500">{{ channel.hint }}</span>
              </span>
              <i class="fas fa-arrow-right ml-auto text-sm text-navy-300 transition group-hover:translate-x-1 group-hover:text-navy-900"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const points = [
  'Free, no-obligation quotes',
  'Fully insured work',
  'Bishop\'s Stortford and surrounding areas'
]

const channels = [
  {
    icon: 'fas fa-phone',
    label: 'Phone',
    value: '07534 490921',
    hint: 'Fastest way to reach us',
    href: 'tel:+447534490921'
  },
  {
    icon: 'fas fa-envelope',
    label: 'Email',
    value: 'mcleanit@mail.com',
    hint: 'Send over the details',
    href: 'mailto:mcleanit@mail.com'
  },
  {
    icon: 'fab fa-instagram',
    label: 'Instagram',
    value: '@mcleanitltd',
    hint: 'See recent jobs',
    href: 'https://www.instagram.com/mcleanitltd/',
    external: true
  },
  {
    icon: 'fab fa-facebook',
    label: 'Facebook',
    value: 'MCLEANIT Ltd',
    hint: 'Message us directly',
    href: 'https://facebook.com/georgemcl94',
    external: true
  }
]
</script>
